
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TaskNavigationService } from '../../../services/task-navigation.service';

type UploadSuccessResult = {
  document_name: string;
  folder_name?: string;
  task_id?: string;
  message?: string;
};

interface DialogUploadSuccessData {
  // Nuevo: lista de resultados
  results?: UploadSuccessResult[];
  // Compatibilidad: datos individuales
  document_name?: string;
  folder_name?: string;
  task_id?: string;
  message?: string;
}

@Component({
    selector: 'app-dialog-upload-success',
    templateUrl: './dialog-upload-success.component.html',
    styleUrls: ['./dialog-upload-success.component.scss'],
    standalone: false
})
export class DialogUploadSuccessComponent {
  copiedTaskId: string | null = null;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogUploadSuccessData,
    private dialogRef: MatDialogRef<DialogUploadSuccessComponent>,
    private router: Router,
    private taskNavService: TaskNavigationService
  ) {}

  goToTask(task_id?: string): void {
    this.dialogRef.close();
    if (task_id) {
      this.taskNavService.setTaskId(task_id);
    }
    this.router.navigate(['/tasks']);
  }

  copyTaskId(task_id?: string): void {
    if (!task_id) return;
    navigator.clipboard.writeText(task_id).then(() => {
      this.copiedTaskId = task_id;
      setTimeout(() => this.copiedTaskId = null, 2000);
    });
  }

  // Para compatibilidad: si no hay results, devolver array con un solo elemento
  get results(): UploadSuccessResult[] {
    if (this.data.results && this.data.results.length > 0) {
      return this.data.results;
    }
    // fallback para compatibilidad
    return [{
      document_name: this.data.document_name || '',
      folder_name: this.data.folder_name,
      task_id: this.data.task_id,
      message: this.data.message
    }];
  }
}
